import { LANGUAGE_ITEMS } from '@app/i18n/i18.utils';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { OptionItem, Select } from '../select';

export const LanguageSwitcher: React.FC = () => {
  const {
    i18n: { changeLanguage, resolvedLanguage },
  } = useTranslation();

  return (
    <div className="flex items-center">
      <Select
        value={resolvedLanguage}
        onChange={(event) => {
          changeLanguage(event.target.value);
        }}
      >
        {LANGUAGE_ITEMS.map((lng) => (
          <OptionItem value={lng.value} key={lng.value}>
            <div className="flex items-center gap-3">
              {lng.icon}
              {lng.title}
            </div>
          </OptionItem>
        ))}
      </Select>
    </div>
  );
};
